import { http, toQuery } from '@/lib/apiClient';

export type AttachmentEntityType = 'PO' | 'PO_DOCUMENT' | 'PO_ATTACHMENT' | 'PURCHASE_ORDER' | 'GOODS_RECEIPT' | 'GRN' | 'INVOICE' | 'PAYMENT' | 'VENDOR' | 'VENDOR_KYC';
export interface AttachmentDto { id: string; entityType: AttachmentEntityType; entityId: string; fileName: string; mimeType: string; storageKey: string; fileSize: number; checksum: string; uploadedBy: string; createdAt: string }
export interface AttachmentSearchItem extends AttachmentDto {
  documentType?: string | null;
  documentNo?: string | null;
  linkedRecordNo?: string | null;
  linkedRecordType?: AttachmentEntityType | null;
  linkedRecordId?: string | null;
  linkedRecordNumber?: string | null;
  linkedRecordUrl?: string | null;
  vendorId?: string | null;
  vendorName?: string | null;
  vendorCode?: string | null;
  poId?: string | null;
  poNumber?: string | null;
  uploadedByName?: string | null;
  status?: string | null;
  previewUrl?: string | null;
  downloadUrl?: string | null;
}
export interface AttachmentSearchQuery {
  page?: number;
  pageSize?: number;
  search?: string;
  source?: string;
  entityType?: string;
  vendorId?: string;
  poId?: string;
  uploadedFrom?: string;
  uploadedTo?: string;
  status?: string;
}
export interface PagedAttachments { items: AttachmentSearchItem[]; page: number; pageSize: number; totalCount: number }

export const attachmentsApi = {
  list: (query: AttachmentSearchQuery = {}) => http.get<PagedAttachments>(`/api/v1/attachments${toQuery({ page: query.page ?? 1, pageSize: query.pageSize ?? 50, search: query.search, source: query.source, entityType: query.entityType, vendorId: query.vendorId, poId: query.poId, uploadedFrom: query.uploadedFrom, uploadedTo: query.uploadedTo, status: query.status })}`),
  upload: (entityType: AttachmentEntityType, entityId: string, file: File) => {
    const form = new FormData();
    form.append('entityType', entityType);
    form.append('entityId', entityId);
    form.append('file', file);
    return http.post<AttachmentDto>('/api/v1/attachments', form);
  },
  metadata: (id: string) => http.get<AttachmentDto>(`/api/v1/attachments/${id}`),
  download: (id: string) => http.blob(`/api/v1/attachments/${id}/content`),
  delete: (id: string) => http.delete<void>(`/api/v1/attachments/${id}`),
};
